import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { Stack, TextField, IconButton, InputAdornment,Typography,Link,Select,MenuItem,Paper, Checkbox, Box, Snackbar, Alert} from '@mui/material';
import instance from 'src/instance/instance';
import useAuthentication from 'src/hooks/useAuthentication';
import env from 'src/env';


export default function Verify({row,refresh}) {
  const { getUser } = useAuthentication();
  const id = getUser().id

  const initialValues= {
    id:row.id,
    verifyBy:id,
  }
  
  const [open, setOpen] = React.useState(false);
  const [data,setData] = React.useState(initialValues)
  const [openResponse, setOpenResponse] = React.useState(false);
  const [message, setMessage] = React.useState('');
  const [severity, setSeverity] = React.useState('');
  

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const handleVerify = async () => {

    try {
      // Make a POST request using Axios
      instance.post("./donors/verifydonorsolicitor",data).then((response) => {
        if (response.data.error){
          openSnackBar('error',response.data.error)
          refresh();
          setOpen(false);

        }else{
          openSnackBar('success',response.data)
          setOpen(false);
          refresh();

        // console.error(response);

        }
        })
  
      } catch (error) {
        // console.error(error);
        openSnackBar('error',error)
      } 

  }
  const closeSnackBar = (event,reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpenResponse(false);
    setSeverity('')
    setMessage('')
  };
  const openSnackBar = (severity,message) => {

    setSeverity(severity)
    setMessage(message)
    setOpenResponse(true);
  };
  return (
    <div>
      <Snackbar
        anchorOrigin={{     vertical: 'top',
          horizontal: 'center',}}
        open={openResponse}
        autoHideDuration={6000}
        onClose={closeSnackBar}
        message={message}
        // action={action}
      >
      <Alert severity={severity}>{message}</Alert>
      </Snackbar>
      <Button variant="outlined" onClick={handleClickOpen}>
        Verify Donor Solicitor 
      </Button>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Verify Donor Solicitor Account?"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">   
          <Stack spacing={2}>
          Bank Account Detail
          </Stack>
          <Stack spacing={2}>
          Bank Account Number : {row.bankAccount}
            <Stack spacing={2}>
            <Box  component="img" src={`${env.REACT_APP_BACKEND}${row.bankfile}`} sx={{ width: 1000, height: 1000 }} />
            
            </Stack>
          </Stack>

          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Back</Button>
          <Button onClick={handleClose}>Reject</Button>
          <Button onClick={handleVerify} autoFocus>
            Verify
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}